<ng-container *ngIf="model">
  <entity-icon class="query-item-icon" [model]="model.icon" [size]="'20px'"></entity-icon>
  <result-title [model]="{ text: model.title }" [selected]="selected"></result-title>
  <result-subtitle [model]="{ text: model.subtitle }" [highlights]="highlights"></result-subtitle>
</ng-container>
